import React, { Fragment, useEffect, useState } from "react";


const AboutPage = () => {
    return (
        <Fragment>
            <h1 className="mt-5">About Page</h1>

            <h3 className="mt-3 mb-2">How is burnout related to the SDGs?</h3>

            <p>Productivity has fallen greatly during the pandemic as people feel increase pressures by the strict measures implemented.</p>

            <p>Extroverts in particular are affected by the lack of social interaction with others due to the safe distancing measures.</p>

            <p>This additional stress can negatively impact their mental health and in turn their productivity at work.</p>

            <p>Thus there is a need to find a way for workers to deal with the additional pressures during the pandemic to set the economy on the right track.</p>

        </Fragment>
    );    
}

export default AboutPage;